const Trash = () => {
  return (
    <svg
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Trash</title>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g stroke="#000000" strokeLinecap="round" strokeLinejoin="round">
          <g transform="translate(2.000000, 2.000000)">
            <path
              d="M1,2 L1,10.5333333 C1,10.7947556 1.22385763,11 1.5,11 L10.5,11 C10.7761424,11 11,10.7947556 11,10.5333333 L11,2 L1,2 Z"
              fillRule="nonzero"
            ></path>
            <line x1="0" y1="2" x2="12" y2="2"></line>
            <path
              d="M3.5,0 C3.22385763,0 3,0.223857625 3,0.5 L3,2 L9,2 L9,0.5 C9,0.223857625 8.77614237,0 8.5,0 L3.5,0 Z"
              fillRule="nonzero"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
};

export { Trash };
